import React, { ReactElement } from "react";

//context
import { DeliverySectionContext } from "@cart-client/contexts/DeliverySectionContext";

//hooks
import { useDeliverySectionContext } from "@cart-client/hooks/useDeliverySectionContext";

export interface IProps {
    children: React.ReactNode;
    canShowTimer: boolean;
}

export function DeliverySectionContextProvider({ children, canShowTimer }: IProps): ReactElement {
    const deliverySectionContextValue = useDeliverySectionContext(canShowTimer);

    return (
        <DeliverySectionContext.Provider value={deliverySectionContextValue}>
            {children}
        </DeliverySectionContext.Provider>
    );
}
